import { Injectable } from "@angular/core"
import { Subject, throttleTime } from "rxjs"

@Injectable({
	providedIn: "root",
})
export class LogoutTimerService {
	lastActivity: Date = new Date()
	logoutInMins: number = 15
	timeout: any = null
	isLoggedOut: boolean = false
	onLogout: Function = null

	init(logoutInMins: number, onLogout: Function) {
		this.logoutInMins = logoutInMins
		this.onLogout = onLogout
		this.restartLogoutTimer()
		const motionAndClickSubject = new Subject()

		motionAndClickSubject.pipe(throttleTime(500)).subscribe(() => {
			this.restartLogoutTimer()
		})

		window.document.addEventListener("mousemove", () =>
			motionAndClickSubject.next(true)
		)
		window.document.addEventListener("click", () =>
			motionAndClickSubject.next(true)
		)
	}
	logout() {
		this.isLoggedOut = true
		this.onLogout?.()
	}
	restartLogoutTimer() {
		clearTimeout(this.timeout)
		if (this.isLoggedOut) {
			return
		}
		const timeDiffFromLastActivity =
			new Date().getTime() - this.lastActivity.getTime()
		const timeoutMillis = this.logoutInMins * 60 * 1000 //the timeout in millis
		const doLogout = timeDiffFromLastActivity > timeoutMillis
		if (doLogout) {
			this.logout()
			return
		}
		this.lastActivity = new Date()

		this.timeout = setTimeout(() => {
			this.logout()
		}, timeoutMillis)
	}
}
